import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';

const AuthDiagnostic = () => {
  const [urlInfo, setUrlInfo] = useState({});
  const [hashInfo, setHashInfo] = useState({});

  useEffect(() => {
    // Get current URL info
    setUrlInfo({
      origin: window.location.origin,
      href: window.location.href,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      fullUrl: window.location.toString()
    });

    // Parse hash
    const hash = window.location.hash;
    if (hash && hash.includes('session_id=')) {
      const cleanHash = hash.startsWith('#') ? hash.substring(1) : hash;
      const sessionId = cleanHash.split('session_id=')[1]?.split('&')[0];
      setHashInfo({
        rawHash: hash,
        cleanHash: cleanHash,
        hasSessionId: true,
        sessionIdLength: sessionId ? sessionId.length : 0,
        sessionIdPreview: sessionId ? sessionId.substring(0, 30) + '...' : 'NONE'
      });
    } else {
      setHashInfo({
        rawHash: hash,
        hasSessionId: false
      });
    }
  }, []);

  const testRedirect = () => {
    const redirectUrl = `${window.location.origin}/`;
    const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    alert(`Will redirect to:\n${authUrl}\n\nRedirect URL:\n${redirectUrl}`);
  };

  return (
    <div className="min-h-screen p-8" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Card className="glass border-white/20 max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl text-white">Authentication Diagnostic</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          
          <div>
            <h3 className="text-white font-semibold mb-2">Current URL Information:</h3>
            <pre className="bg-black/30 p-4 rounded text-white text-sm overflow-auto">
              {JSON.stringify(urlInfo, null, 2)}
            </pre>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2">Hash/Session ID Information:</h3>
            <pre className="bg-black/30 p-4 rounded text-white text-sm overflow-auto">
              {JSON.stringify(hashInfo, null, 2)}
            </pre>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2">Expected Behavior:</h3>
            <div className="bg-black/30 p-4 rounded text-white text-sm space-y-2">
              <p>1. User clicks "Get Started with Google"</p>
              <p>2. Redirects to: https://auth.emergentagent.com/?redirect=[encoded_url]</p>
              <p>3. After Google login, returns to: [app_url]/#session_id=[token]</p>
              <p>4. Frontend should detect session_id in hash and process it</p>
              <p>5. Backend creates session and returns user data</p>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2">Status Check:</h3>
            <div className="bg-black/30 p-4 rounded text-white text-sm space-y-2">
              <p>✓ Current origin: {window.location.origin}</p>
              <p>{hashInfo.hasSessionId ? '✓' : '✗'} Session ID in URL: {hashInfo.hasSessionId ? 'YES' : 'NO'}</p>
              {hashInfo.hasSessionId && (
                <>
                  <p>✓ Session ID length: {hashInfo.sessionIdLength} chars</p>
                  <p>✓ Session ID preview: {hashInfo.sessionIdPreview}</p>
                </>
              )}
            </div>
          </div>

          <Button
            onClick={testRedirect}
            className="w-full bg-white text-purple-700 hover:bg-gray-100"
          >
            Test Redirect URL (Preview Only)
          </Button>

          <div className="bg-yellow-500/20 border border-yellow-500/40 rounded p-4">
            <p className="text-white text-sm">
              <strong>Instructions:</strong> Send this page URL to the new user who can't login. 
              Ask them to visit it and screenshot what they see, especially the URL and hash information.
            </p>
          </div>

          <div className="text-center">
            <a href="/" className="text-white hover:text-white/80 underline text-sm">
              Back to Home
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthDiagnostic;
